module.exports = __webpack_public_path__ + "img/Koios_white.161e4a51.png";